<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2021-06-20 22:23:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <UserNav />
        <div class="main_box">
            <el-main>
                <UserNavList />
                <div class="user_box">
                    <div class="user_div">
                        <div class="user_info">
                            <div class="user_info_top">
                                <div class="user_avatar">
                                    <i class="iconfont icon-al-huazhuangpin"></i>
                                </div>
                                <div class="user_item_box">
                                    <div class="user_item user_tit">
                                        歡迎您~ <span>{{ user_data.user_name }}</span>
                                    </div>
                                    <div class="user_item">
                                        會員賬號：{{ user_data.user_id }}
                                    </div>
                                </div>
                            </div>
                            <div class="user_item_bottom">
                                <div class="user_item_bottom_box">
                                    <p>消費金額：<span>{{ all_price }}</span></p>
                                    <p>人民幣：<span>{{ (all_price / basic_info['WEB_RMB']).toFixed(2) }}</span></p>
                                    <p>臺幣：<span>{{ (all_price / basic_info['WEB_TAIWAN']).toFixed(2) }}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="user_div_bottom"></div>
                    <div class="user_div2">
                        <div class="user_div2_tit">
                            訂單信息
                        </div>
                        <div class="order_info">
                            <router-link :to="`/Cart`">
                                <i class="iconfont icon-al-gouwucheman"></i>
                                <div>購物車</div>
                            </router-link>
                            <router-link :to="`/OrderList`">
                                <i class="iconfont icon-al-fukuan"></i>
                                <div>未付款</div>
                            </router-link>
                            <router-link :to="`/OrderList`">
                                <i class="iconfont icon-al-fahuo-"></i>
                                <div>已付款</div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </el-main>
        </div>
        <MainFooter />
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import UserNav from "@/components/UserNav";
import UserNavList from "@/components/UserNavList";
import MainFooter from "@/components/Footer";
import { getCenterInfo } from "@/api/goodsAPI";
// 辅助函数，可以使用命名空间获取$store的数据
import { mapState } from "vuex";
export default {
    components: {
        MainHeader,
        UserNav,
        MainFooter,
        UserNavList,
    },
    data() {
        return {
            all_price: 0,
        };
    },
    computed: {
        ...mapState("loginUser", ["user_data", "islogining"]),
        ...mapState("BasicInfo", ["basic_info"]),
    },
    created() {
        this.get_all_price();
    },
    methods: {
        async get_all_price() {
            let resp = await getCenterInfo();
            this.all_price = resp.all_price;
        },
    },
};
</script>

<style scoped lang="scss">
.main_box {
    background: #f5f6f8 url("../../public/img/user-bg.jpg") center 0 no-repeat;
    min-height: 600px;
    height: auto;
    overflow: hidden;
    .el-main {
        width: 1000px;
        margin: 24px auto;
        padding: 0;
        background-color: rgba(255, 255, 255, 0);
        .user_box {
            float: right;
            width: 820px;
            min-height: 600px;
            _height: 600px;
            margin-bottom: 20px;
            .user_div {
                background: #fff;
                border-color: #e4e4e4;
                border-width: 1px 1px 0 1px;
                border-style: solid;
                height: auto;
                .user_info {
                    background: #fff;
                    border-color: #e4e4e4;
                    border-width: 1px 1px 0 1px;
                    border-style: solid;
                    height: auto;
                    overflow: hidden;
                    .user_info_top {
                        margin: 24px 0;
                        padding-left: 25px;
                        position: relative;
                        height: auto;
                        overflow: hidden;
                        .user_avatar {
                            float: left;
                            background-color: #fef0eb;
                            width: 92px;
                            height: 92px;
                            border-radius: 92px;
                            border: 4px solid #fff;
                            box-shadow: 2px 2px 2px #d8d7d7;
                            position: relative;
                            top: 0;
                            overflow: hidden;
                            i {
                                line-height: 100px;
                                display: block;
                                text-align: center;
                                font-size: 40px;
                                color: #f29d83;
                            }
                        }
                        .user_item_box {
                            float: left;
                            margin-left: 24px;
                            margin-top: 24px;
                            .user_item {
                                padding: 4px 0;
                                font-size: 14px;
                            }
                            .user_tit {
                                span {
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                    .user_item_bottom {
                        padding-bottom: 12px;
                        background-position: center bottom;
                        height: auto;
                        overflow: hidden;
                        padding: 0 30px 12px;
                        .user_item_bottom_box {
                            padding: 10px 30px;
                            background-color: #f5f8f9;
                            height: auto;
                            overflow: hidden;
                            p {
                                width: 140px;
                                float: left;
                                height: 22px;
                                line-height: 22px;
                                _display: inline;
                                display: inline;
                                padding: 0 0 0 30px;
                                font-size: 12px;
                                color: #333;
                                span {
                                    font-weight: bold;
                                }
                            }
                            p:first-child {
                                padding: 0;
                            }
                        }
                    }
                }
            }
            .user_div_bottom {
                background: url("../../public/img/userInfobuttom_bg.png")
                    repeat-x;
                height: 5px;
            }
            .user_div2 {
                height: auto;
                overflow: hidden;
                color: #333;
                background-color: #fff;
                border: 1px #ececec solid;
                margin-top: 16px;
                .user_div2_tit {
                    background-color: #f9f9f9;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 44px;
                    padding-left: 32px;
                    position: relative;
                    border-bottom: 1px #ececec solid;
                }
                .user_div2_tit::before {
                    content: "";
                    position: absolute;
                    background-color: #ff2832;
                    width: 2px;
                    height: 14px;
                    top: 15px;
                    left: 20px;
                }
                .order_info {
                    padding: 44px 0 36px 0;
                    border-bottom: 1px solid #f5f6f8;
                    a {
                        display: inline-block;
                        position: relative;
                        margin-left: 146px;
                        width: 68px;
                        text-align: center;
                        font-size: 14px;
                        color: #333;
                        i {
                            background-color: #fef0eb;
                            width: 70px;
                            height: 70px;
                            border-radius: 70px;
                            border: 4px solid #fff;
                            box-shadow: 2px 2px 2px #d8d7d7;
                            position: relative;
                            top: 0;
                            overflow: hidden;
                            font-size: 60px;
                            display: block;
                            font-size: 41px;
                            line-height: 70px;
                            text-align: center;
                            color: #f29d83;
                        }
                        div {
                            padding-top: 22px;
                            width: 80px;
                            text-align: center;
                        }
                    }
                    a:hover {
                        color: #fa9ea3;
                        i {
                            border: 4px solid #ffc0c3;
                        }
                    }
                }
            }
        }
    }
}
</style>
